const gccsNewPopupConfirm = {
  controller: 'NewPopupConfirmController',
  template: require('./template.pug')
};

angular.module('shared-components').component('gccsNewPopupConfirm', gccsNewPopupConfirm);
